import { defineStore } from 'pinia'

export const useBlogStore = defineStore('blog', {
  state: () => ({
    posts: [
      {
        id: 1,
        title: '示例文章',
        content: '这是一篇示例文章的内容...',
        date: '2024-01-14',
        comments: []
      }
    ]
  }),
  
  actions: {
    addPost(post) {
      const newPost = {
        id: Date.now(),
        date: new Date().toISOString().split('T')[0],
        comments: [],
        ...post
      }
      this.posts.push(newPost)
      return newPost
    },
    
    updatePost(postId, updatedPost) {
      const index = this.posts.findIndex(p => p.id === postId)
      if (index !== -1) {
        this.posts[index] = { ...this.posts[index], ...updatedPost }
      }
    },
    
    deletePost(postId) {
      this.posts = this.posts.filter(p => p.id !== postId)
    },
    
    addComment(postId, comment) {
      const post = this.posts.find(p => p.id === postId)
      if (post) {
        post.comments.push({
          id: Date.now(),
          date: new Date().toISOString().split('T')[0],
          ...comment
        })
      }
    }
  }
}) 